// extracted by mini-css-extract-plugin
export default {"note":"LegalConsentNote_note__U5fLw"};